<template>
  <div>
    <portal selector="#page-toolbar-actions">
      <v-button
        v-if="pageActions && pageActions.length !== 0"
        class="v-toolbar__button"
        data-cy="page-actions-panel-button"
        secondary
        ghost
        round
        @click="() => $router.push(actionPanelHash)"
      >
        <v-icon icon="more_horiz" />
      </v-button>
    </portal>

    <v-modal x-short>
      <template :slot="actionPanelHash">
        <action-header />
        <action-body>
          <v-button
            v-for="action in pageActions"
            :key="action.uid"
            block
            secondary
            ghost
            @click="() => triggerAction({ pageId, uid: action.uid })"
          >
            <v-icon :icon="action.icon"></v-icon>
            {{ action.text }}
          </v-button>
        </action-body>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

import ActionHeader from "@/components/modals/shared/ActionHeader"
import ActionBody from "@/components/modals/shared/ActionBody"

export default {
  components: {
    ActionHeader,
    ActionBody
  },

  props: {
    pageId: { type: [Number, String], required: true }
  },

  computed: {
    ...mapState("pageActionPanel", ["actions"]),

    actionPanelHash() {
      return `#actions-${this.pageId}`
    },

    pageActions() {
      return this.actions[this.pageId]
    }
  },

  methods: {
    ...mapActions("pageActionPanel", ["triggerAction"])
  }
}
</script>
